export let everythingSelectedSearch = "ChjwZb";
export default {everythingSelectedSearch};